module.exports = __webpack_public_path__ + "static/media/Parth_image.39dfb46e.jpg";